// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"378":"2ad087df","849":"ab93e156"}[chunkId] + ".chunk.css";
};